import AccessibilityIcon from 'assets/icons/accessibility.svg';
import cn from 'classnames/bind';
import Link from 'next/link';
import { Row } from 'ui';

import s from './Footer.module.css';

const cx = cn.bind(s);
const brainableCopyright = `Copyright ©${new Date().getFullYear()} My personality.`;

export default function ShortFooter() {
  return <Row className={cx('shortFooterRow')}>
    <div className={cx('shortFooterCopyrightCol')}>
      { brainableCopyright }
    </div>
    <div className={cx('shortFooterNavigationCol')}>
      <nav className={cx('shortNav')}>
        <ul className={cx('shortMenu')}>
          <li className={cx('shortMenuItem')} data-acsb-custom-trigger="true">
            <AccessibilityIcon className={cx('shortMenuItemIcon')} />
          Accessibility
          </li>
          <li className={cx('shortMenuItem')}>
            <Link href={'/faq'}>
              Support center
            </Link>
          </li>
          <li className={cx('shortMenuItem')}>
            <Link href={'/terms-conditions'}>
              Terms of use
            </Link>
          </li>
          <li className={cx('shortMenuItem')}>
            <Link href={'/privacy'}>
              Privacy policy
            </Link>
          </li>
          <li className={cx('shortMenuItem')}>
            <Link href={'/contact'}>
              Contact us
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  </Row>
}